import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgPaymentIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="payment_svg__nc-icon-wrapper">
      <path d="M10 36a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H10z" />
      <path d="M58 4H6C3.243 4 1 6.243 1 9v36c0 2.757 2.243 5 5 5h25v-2H6c-1.654 0-3-1.346-3-3V27h58v10h2V9c0-2.757-2.243-5-5-5zm3 13H3V9c0-1.654 1.346-3 3-3h52c1.654 0 3 1.346 3 3v8z" />
      <path
        data-color="color-2"
        d="M48 36c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 13h-4v4a1 1 0 0 1-2 0v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgPaymentStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgPaymentIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const PaymentIcon: any = SvgPaymentStyle;
export default PaymentIcon;
